import { ROUTES } from 'shared/constants';
import { GetRoutesFn, GuestRoute } from 'shared/routes/';

import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { EmailRegistrationPage } from './pages/EmailRegistrationPage';
import { PasswordRecoverySentPage } from './pages/PasswordRecoverySentPage';
import { PasswordResetPage } from './pages/PasswordResetPage';
import { RequestAccessPage } from './pages/RequestAccessPage';

export const getOnboardingRoutes: GetRoutesFn = () => [
  {
    routeComponent: GuestRoute,
    path: ROUTES.public.changePassword,
    component: ChangePasswordPage,
    exact: true,
  },
  {
    routeComponent: GuestRoute,
    path: ROUTES.public.recovery,
    component: PasswordResetPage,
    exact: true,
  },
  {
    routeComponent: GuestRoute,
    path: ROUTES.public.recoverySent,
    component: PasswordRecoverySentPage,
    exact: true,
  },
  {
    routeComponent: GuestRoute,
    path: ROUTES.public.request,
    component: RequestAccessPage,
    exact: true,
  },
  {
    routeComponent: GuestRoute,
    path: ROUTES.public.register,
    exact: true,
    component: EmailRegistrationPage,
  },
];
